// Business timestamps are stored as naive UTC — always show them in IST.
export function formatIst(iso) {
  if (!iso) return "—";
  const s = /Z|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "—";
  return `${d.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  })} IST`;
}
